import { render, staticRenderFns } from "./BuyCover.vue?vue&type=template&id=2b6b05e4&scoped=true"
import script from "./BuyCover.vue?vue&type=script&lang=js"
export * from "./BuyCover.vue?vue&type=script&lang=js"
import style0 from "./BuyCover.vue?vue&type=style&index=0&id=2b6b05e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b05e4",
  null
  
)

export default component.exports